export default function (value, defaultValue) {
  if (value == null) {
    return defaultValue
  }

  return (value === true) ? 'Yes' : 'No'
}
